import { appInsights } from "@/main";
import { Vue } from "vue-property-decorator";

export const MsalUtility = new Vue({
  methods: {
    logout(redirectToRouteName?: string) {
      appInsights.clearAuthenticatedUserContext();
      this.$msal.logout(redirectToRouteName);
    },
  },
});
